const fetchService = async (url: string, method: string = 'GET', params: any) => {
  const queryParams = Object.keys(params).map(key => key + '=' + params[key]).join('&');
  const result = await fetch(`${url}${queryParams ? `?${queryParams}` : ''}`, { method })
  return result.json()
}

export default fetchService